import type { WireAppTheme } from "@glide/theme";

export function isDarkAppTheme(theme: WireAppTheme): boolean {
    return /DarkWireApp/i.test(theme.overlayName);
}
